<div class="item-network">
  <div class="item-network__wrapper">
    <h4 class="item-network__title">{{ title }}</h4>
    <p class="item-network__description">
      <ng-content></ng-content>
    </p>
    <a class="item-network__button" [routerLink]="link"> acessar </a>
  </div>
</div>
